import axios, { AxiosInstance } from "axios";

export const apiAxios: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
});
